import { locationData } from '../data/locations';

export const useLocation = (locationName) => {
  return locationData.find((l) => l.name === locationName);
};
